<template>
    <section class="main-section">
        <div class="container">
            <div v-if="this.$slots['tit']" class="tit-wrap tit-wrap--lg text-center">
                <h2 class="tit tit--lg"><slot name="tit" /></h2>
                <p v-if="this.$slots['txt']" class="txt txt--lg line-height-135"><slot name="txt" /></p>
            </div>
            <slot />
        </div>
    </section>
</template>

<script>
export default {
    props: {
        tit: String,
        txt: String,
    },
};
</script>

<style lang="scss" scoped>
.main-section {
    padding: 80px 0;
    &--sm {
        padding: 50px 0;
    }
}
@media (min-width: 768px) {
    .main-section {
        padding: 100px 0;
        &--sm {
            padding: 70px 0;
        }
    }
}
@media (min-width: 1024px) {
    .main-section {
        padding: 160px 0;
        &--sm {
            padding: 100px 0;
        }
    }
}
</style>
